// Checks if a file has been changed by calling arrayBuffer(). If the call fails it means the file has been changed.
export const hasUploadedFileChanged = (file: File): Promise<boolean> =>
  new Promise((resolve) => {
    file
      .slice(0, 1)
      .arrayBuffer()
      .then(() => resolve(false))
      .catch(() => resolve(true));
  });
